<template>
    <div class="travel-item">
        <div class="travel-item__image">
            <img :src="args.image" alt="">
        </div>
        <div class="travel-item__title">
            {{ args.title }}
        </div>
        <div class="travel-item__description" v-html="args.description"></div>
        <div class="travel-item__description-extra" v-html="args.descriptionExtra"></div>
        <div class="travel-item__button">
            <a :href="args.url" class="btn btn--block btn--orange-outline">
                Get Discounted Rates Today
            </a>
        </div>
    </div>
</template>
<script>
    export default {

        components: {

        },

        props: [
            'args'
        ],

        data: function() {
            return {

            }
        },

        methods: {

        },

        created: function() {

        }

    }
</script>


// WEBPACK FOOTER //
// TravelModal.vue?ade1eb1c